export const gender = {
  male: 'Masculino',
  female: 'Feminino',
  other: 'Outro',
};
